import { ROUTE_NAME } from 'enums/routes'

export const IL_DIR_GROUP_TYPE = {
  DIRECTORY_CATEGORY: 'DirectoryCategory',
  DIRECTORY_COMPANY: 'Company'
}

const IL_DIR_GROUP_TYPES_BY_ROUTE_NAME = {
  [ROUTE_NAME.FOREX_BROKERS]: [IL_DIR_GROUP_TYPE.DIRECTORY_CATEGORY],
  [ROUTE_NAME.DIRECTORY_COMPANY]: [IL_DIR_GROUP_TYPE.DIRECTORY_COMPANY]
}

export const getIlDirGroupTypesByPageName = pageName =>
  IL_DIR_GROUP_TYPES_BY_ROUTE_NAME[pageName]

const IL_DIR_TEMPLATE_PARAM = {
  [IL_DIR_GROUP_TYPE.DIRECTORY_CATEGORY]: {
    META_TITLE: 'DIRECTORY_CATEGORY_NAME',
    META_DESCRIPTION: 'DIRECTORY_CATEGORY_NAME'
  },
  [IL_DIR_GROUP_TYPE.DIRECTORY_COMPANY]: {
    META_TITLE: 'COMPANY_NAME',
    META_DESCRIPTION: 'COMPANY_NAME'
  }
}

const IL_DIR_TEMPLATE_PARAMS_LIST = Object.values(IL_DIR_TEMPLATE_PARAM)

export const IL_DIR_META_TITLE_PARAMS_REGEX = new RegExp(
  IL_DIR_TEMPLATE_PARAMS_LIST.map(({ META_TITLE }) => META_TITLE).join('|'),
  'g'
)

export const IL_DIR_META_DESCRIPTION_PARAMS_REGEX = new RegExp(
  IL_DIR_TEMPLATE_PARAMS_LIST.map(
    ({ META_DESCRIPTION }) => META_DESCRIPTION
  ).join('|'),
  'g'
)
